import { getColumnWidth } from "../../../style/datagridMQ";
import { Button } from "@mui/material";

// constants
export const TIME_FRAMES = {
  MONTH: "Month",
  WEEK: "Week",
  DAY: "Day",
};

export const CATEGORIES = {
  BAR_CLUB: "Bar/Club",
  WHOLESALER: "Wholesaler",
  CUSTOMER: "Customer",
};

//Bar columns
export const getBarColumns = (handleViewBarDetails) => [
  {
    field: "Name",
    headerName: "Bar/Club Name",
    width: getColumnWidth("column"),
    renderCell: (params) => (!params.row.isChild ? params.value : null),
  },
  {
    field: "Email",
    headerName: "Email",
    width: getColumnWidth("column"),
    renderCell: (params) => (!params.row.isChild ? params.value : null),
  },
  {
    field: "Contact",
    headerName: "Phone No",
    width: getColumnWidth("column"),
    renderCell: (params) => (!params.row.isChild ? params.value : null),
  },
  {
    field: "Address",
    headerName: "Address",
    width: getColumnWidth("column"),
    renderCell: (params) => (!params.row.isChild ? params.value : null),
  },
  {
    field: "action",
    headerName: "Action",
    width: getColumnWidth("column"),
    sortable: false,
    renderCell: (params) => (
      <Button
        variant="contained"
        size="small"
        onClick={() => handleViewBarDetails(params.row)}
        sx={{
          bgcolor: "#2563eb",
          color: "white",
          textTransform: "none",
          fontWeight: 500,
          px: 2,
          py: 0.75,
          borderRadius: 2,
          "&:hover": {
            bgcolor: "#1d4ed8",
            boxShadow: "0 4px 12px rgba(37, 99, 235, 0.3)",
          },
          "&:disabled": {
            bgcolor: "#e5e7eb",
            color: "#9ca3af",
          },
        }}
      >
        View Details
      </Button>
    ),
  },
];

export const barDayColumns = [
  {
    field: "Date",
    headerName: "Date",
    width: getColumnWidth("column"),
  },
  {
    field: "MostSoldBrand",
    headerName: "Most Sold Brand",
    width: getColumnWidth("column"),
  },
  {
    field: "totalShots",
    headerName: "Shots Sold",
    width: getColumnWidth("column"),
  },
];

export const barWeeklyColumns = [
  { field: "week", headerName: "Week", width: getColumnWidth("column") },
  {
    field: "mostOrderedBrand",
    headerName: "Top Brand",
    width: getColumnWidth("column"),
  },
  {
    field: "totalShots",
    headerName: "Total Shots",
    width: getColumnWidth("column"),
  },
];

export const barMonthColumns = [
  { field: "month", headerName: "Month", width: getColumnWidth("column") },
  {
    field: "mostOrderedBrand",
    headerName: "Top Brand",
    width: getColumnWidth("column"),
  },
  {
    field: "totalShots",
    headerName: "Total Shots",
    width: getColumnWidth("column"),
  },
];

//Wholesaler columns
export const getWholesalerColumns = (handleViewDetails) => [
  {
    field: "Name",
    headerName: "Company Name",
    width: getColumnWidth("column"),
    renderCell: (params) => (!params.row.isChild ? params.value : null),
  },
  {
    field: "Email",
    headerName: "Email",
    width: getColumnWidth("column"),
    renderCell: (params) => (!params.row.isChild ? params.value : null),
  },
  {
    field: "PhoneNo",
    headerName: "Phone No",
    width: getColumnWidth("column"),
    renderCell: (params) => (!params.row.isChild ? params.value : null),
  },
  {
    field: "Address",
    headerName: "Address",
    width: getColumnWidth("column"),
    renderCell: (params) => (!params.row.isChild ? params.value : null),
  },
  {
    field: "action",
    headerName: "Action",
    width: getColumnWidth("column"),
    sortable: false,
    renderCell: (params) => (
      <Button
        variant="contained"
        size="small"
        onClick={() => handleViewDetails(params.row)}
        // disabled={!params.row.dayWiseReport || params.row.dayWiseReport.length === 0}
        sx={{
          bgcolor: "#2563eb",
          color: "white",
          textTransform: "none",
          fontWeight: 500,
          px: 2,
          py: 0.75,
          borderRadius: 2,
          "&:hover": {
            bgcolor: "#1d4ed8",
            boxShadow: "0 4px 12px rgba(37, 99, 235, 0.3)",
          },
          "&:disabled": {
            bgcolor: "#e5e7eb",
            color: "#9ca3af",
          },
        }}
      >
        View Details
      </Button>
    ),
  },
];

export const getWholesalerDayTransactionColumns = [
  {
    field: "Date",
    headerName: "Date",
    width: getColumnWidth("column"),
  },
  {
    field: "MostSoldBrand",
    headerName: "Most Sold Brand",
    width: getColumnWidth("column"),
  },
  {
    field: "Transactions",
    headerName: "Amount",
    width: getColumnWidth("column"),
  },
  {
    field: "BottlesSold",
    headerName: "Bottles Sold",
    width: getColumnWidth("column"),
  },
];

export const wholesalerMonthColumns = [
  {
    field: "month",
    headerName: "Month",
    width: getColumnWidth("column"),
  },
  {
    field: "monthlyTransactions",
    headerName: "Amount",
    width: getColumnWidth("column"),
  },
];

export const wholesalerWeeklyColumns = [
  { field: "week", headerName: "Week", width: getColumnWidth("column") },
  {
    field: "weeklyTransactions",
    headerName: "Amount",
    width: getColumnWidth("column"),
  },
];

//Customer columns
export const getCustomerColumns = [
  {
    field: "name",
    headerName: "Name",
    width: getColumnWidth("column"),
  },
  {
    field: "email",
    headerName: "Email",
    width: getColumnWidth("column"),
  },
  {
    field: "mobile",
    headerName: "Mobile",
    width: getColumnWidth("column"),
  },
  {
    field: "orderBrand",
    headerName: "Order Brand",
    width: getColumnWidth("column"),
  },
  {
    field: "ordered",
    headerName: "Ordered Quantity",
    width: getColumnWidth("column"),
  },
  {
    field: "total",
    headerName: "Total Amount",
    width: getColumnWidth("column"),
  },
  {
    field: "wholesaler_name",
    headerName: "Wholesaler Name",
    width: getColumnWidth("column"),
  },
  {
    field: "date",
    headerName: "Order Date",
    width: getColumnWidth("column"),
    renderCell: (params) => {
      const rawDate = new Date(params.value);
      return isNaN(rawDate)
        ? "Invalid Date"
        : rawDate.toLocaleDateString("en-GB");
    },
  },
];
